import { render, staticRenderFns } from "./VSkeletonShimmer.vue?vue&type=template&id=6f77a5fe"
import script from "./VSkeletonShimmer.vue?vue&type=script&lang=js"
export * from "./VSkeletonShimmer.vue?vue&type=script&lang=js"
import style0 from "./VSkeletonShimmer.vue?vue&type=style&index=0&id=6f77a5fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports